import {Container, Col, Row }from 'react-bootstrap';
import ImageContainer from './ImageContainer';
import { CameraReels, Sticky } from 'react-bootstrap-icons';

import { Newspaper} from 'react-bootstrap-icons';


interface ContentProps{
    image: string;
    title: string;
    subtitle: string;
    text: string;
    url: string
    type?: string;
}

function ImageLinkBlock({image, title, subtitle, text, url, type=""}: ContentProps){
    return (
        <> 

                    <Container className="border rounded" onClick={()=> window.open(url, "_blank")}>
                        <Row className="position-relative">
                            <Col className="square-image-block">
                                <ImageContainer img_url={image} />
                            </Col>
                            <div className="pt-2 position-absolute top-0 end-0 color-font-primary color-bg-secondary opacity-75">
                                { (type === "video" ) && <CameraReels className="px-1" size={36} />}
                                { (type === "article" ) && <Newspaper className="px-1" size={36} />}
                                { (type === "post" ) && <Sticky className="px-1" size={36} />}
                            </div>
                        </Row>
                        <Row>
                            <h3 className="text-start font-body color-font-primary font-size-medium">{title}</h3>
                        </Row>
                        <Row>
                            <h3 className="text-start font-body color-font-primary font-size-tiny">{subtitle}</h3>
                        </Row>
                        <Row>
                            <p className="text-start font-body color-font-primary font-size-xs">{text}</p>
                        </Row>
                    </Container>


        </>
    )
}

export default ImageLinkBlock;